import { DockForFtlRouteViewModel } from "../../../../ViewModel/DockForFtlRouteViewModel";
import { EditProjectContextProps } from "../../../EditProjectContext";

export function setDockOnRoute(
  ftlRouteId: number,
  docks: Array<DockForFtlRouteViewModel>,
  EditProjectContext: EditProjectContextProps
) {
  const { project, setProject } = EditProjectContext;
  const updateFtlRoute = project?.FTLRoutes?.map((ftlRoute) => {
    if (ftlRoute.RouteId !== ftlRouteId || !ftlRoute.Docks) {
      return ftlRoute;
    }
    return {
      ...ftlRoute,
      Docks: docks,
    };
  });

  setProject({
    ...project,
    FTLRoutes: updateFtlRoute,
  });
}
